import * as React from "react";
import { ScaleTime, ScaleLinear } from "d3-scale";
import { translateX } from "../../d3chart";
import { TooltipInfo, SequenceState } from "../Data";

interface Props
{
    tooltip: TooltipInfo;
    
    xScale: ScaleTime<number, number>;
    yScales: ScaleLinear<number, number>[];    
    height: number;
}

// SweepLine component which follows the user's mouse pointer
export const SweepLine: React.SFC<Props> =({ tooltip, xScale, yScales, height }) => {
    return tooltip && (
        <g transform={translateX(xScale(tooltip.x))}>
            <line y1={0} y2={height} x1={0} x2={0} stroke="red" strokeWidth="1.5" />
            { tooltip.items.filter(item => item.sequence.state !== SequenceState.Hidden).map(({ sequence, value, dataSetId }, idx) => {
                    const y = yScales[dataSetId](value);
                    return sequence.dotType === 'circle'
                        ? <circle key={idx} r="3" fill={sequence.color} cx={0} cy={y} />
                        : <rect key={idx} fill={sequence.color} x={-3} y={y-3} width={6} height={6} />
                })
            }
        </g>
    );
}


// WEBPACK FOOTER //
// ./src/charts/TimeSeries/SweepLine.tsx